import { Container, Row } from "reactstrap";
import { ModalTitle, UIKits } from "../../../constants";
import BasicModal from "./basicModal";
import CenteredModal from "./centeredModal";
import CustomModals from "./customModals";
import FullscreenModal from "./fullscreenModal";
import SizeModal from "./sizeModal";
import StaticModal from "./StaticModal";
import ToggleModal from "./toggleModal";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const ModalContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ModalTitle} parent={UIKits} />
      <Container fluid>
        <Row>
          <BasicModal />
          <SizeModal />
          <FullscreenModal />
          <CenteredModal />
          <ToggleModal />
          <StaticModal />
          <CustomModals />
        </Row>
      </Container>
    </>
  );
};
export default ModalContainer;
